/**
 * Computes the minimum of the given values
 * @param {Array<number>} input
 * @return {number}
 */
export default function min(input) {
  if (!Array.isArray(input)) {
    throw new Error('input must be an array');
  }

  if (input.length === 0) {
    throw new Error('input must not be empty');
  }

  var min = input[0];
  for (var i = 1; i < input.length; i++) {
    if (input[i] < min) min = input[i];
  }
  return min;
}
